import { render, staticRenderFns } from "./AmlinkSubmissionFile.vue?vue&type=template&id=c0ade9ba"
import script from "./AmlinkSubmissionFile.vue?vue&type=script&lang=js"
export * from "./AmlinkSubmissionFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports